import * as PIXI from "pixi.js";
import genCoordFromAngle from "../../../utils/coord/genCoordFromAngle";
import { drawPencil } from "../Pencil";


export default class CustomCursorDrawingFactory {
  static drawPencilIcon(customCursor: PIXI.Graphics, color: number) {
    drawPencil(customCursor, color);
  }
  static drawDefaultIcon(customCursor: PIXI.Graphics) {
    const startCoord = genCoordFromAngle(Math.PI / 36 * 13, 4)
    const endCoord = genCoordFromAngle(Math.PI / 36 * 13, 24);
    const mid1Coord = genCoordFromAngle(Math.PI / 36 * 9, 16);
    const mid2Coord = genCoordFromAngle(Math.PI / 36 * 17, 16);

    customCursor
      .clear()
      .moveTo(1, 0)
      .lineTo(mid1Coord.x, mid1Coord.y)
      .lineTo(mid2Coord.x, mid2Coord.y)
      .lineTo(1, 0)
      .fill(0x000000)
      .stroke({ width: 2, color: 0x000000, cap: "round" })

      .moveTo(startCoord.x + 1, startCoord.y)
      .lineTo(endCoord.x, endCoord.y)
      .stroke({ width: 3, color: 0x000000, cap: "round" });
  }
  static drawPointerIcon(customCursor: PIXI.Graphics) {
    const w = 3.5;
    const arcStartCoord = genCoordFromAngle(Math.PI, w * 2.5);
    customCursor
      .clear()
      .moveTo(0, 1) // index finger
      .lineTo(0, 20)
      .moveTo(w, 7) // middle finger
      .lineTo(w, 20)
      .moveTo(w * 2, 8) // ring finger
      .lineTo(w * 2, 20)
      .moveTo(w * 3, 9) // pinky
      .lineTo(w * 3, 18)
      .moveTo(-5, 13) // thumb
      .lineTo(0, 20)
      .stroke({ width: w - .5, color: 0x000000, cap: "round"})
      .moveTo(w * 2.5 + arcStartCoord.x, 20 + arcStartCoord.y)
      .arc(w * 1.5, 18, w * 1.8, 0, Math.PI)
      .moveTo(0, 13)
      .rect(0, 13, w * 3, 8)
      .fill(0x000000);
  }
  static drawGrabIcon(customCursor: PIXI.Graphics) {
    const w = 3.5;
    customCursor
      .clear()
      .moveTo(-w, w) // thumb
      .lineTo(-10, -6)
      .moveTo(-w, w) // index finger
      .lineTo(-w - 2, -13)
      .moveTo(0, 0) // middle finger
      .lineTo(-1, -15)
      .moveTo(w, w) // ring finger
      .lineTo(w, -13)
      .moveTo(w * 1.1, w ) // pinky
      .lineTo(w * 2.2, -8)
      .stroke({ width: w - .5, color: 0x000000, cap: "round" })
      .moveTo(0, 0)
      .circle(0, 0, w * 1.8)
      .fill(0x000000);
  }
  static drawRotateIcon(customCursor: PIXI.Graphics) {
    const radius = 10;
    const first = [Math.PI, Math.PI / 8 * 3];
    const second = [0, -Math.PI / 8 * 5];

    const startCoord1 = genCoordFromAngle(first[0], radius);
    const startCoord2 = genCoordFromAngle(second[0], radius);

    customCursor
      .clear()
      .moveTo(startCoord1.x, startCoord1.y)
      .roundPoly(startCoord1.x, startCoord1.y, 7, 3, 3, -Math.PI / 18)
      .moveTo(startCoord2.x, startCoord2.y)
      .roundPoly(startCoord2.x, startCoord2.y, 7, 3, 3, Math.PI / 18 * 17)
      .fill(0x000000)

      .moveTo(startCoord1.x, startCoord1.y)
      .arc(0, 0, radius, first[0], first[1], true)
      .moveTo(startCoord2.x, startCoord2.y)
      .arc(0, 0, radius, second[0], second[1], true)
      .stroke({ width: 4, color: 0x000000 });
  }
  static drawTargetIcon(customCursor: PIXI.Graphics) {
    const length = 14;

    customCursor
      .clear()
      .moveTo(length / 2, length / 2)
      .lineTo(-length / 2, -length / 2)
      .moveTo(length / 2, -length / 2)
      .lineTo(-length / 2, length / 2)
      .stroke({ width: 3, color: 0x000000, cap: "round" })
      .circle(0, 0, 3)
      .fill(0xFFFFFF);
  }
}